// @owners { team: patient-health }
import { Experimentation } from '@alto/experimentation';
import { useNavigation } from '@alto/navigation';
import { fetchPrescriptionFromID } from '~shared/actions/prescriptions';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { useDispatchShared } from '~shared/store';

export const useNavigateToMedDetails = () => {
  const dispatch = useDispatchShared();
  const { navigate } = useNavigation();
  const { value: showNewMedDetails } = Experimentation.useFeatureFlag('new_med_details_and_med_list');

  // @ts-expect-error TS(7006): Parameter 'prescriptionID' implicitly has an 'any' type.
  async function navigateToMeds(prescriptionID, origin) {
    // If no id (such as in SourcePrescription) navigate to overall med list page, otherwise, navigate to specific
    // prescription in med list based on rx number.
    if (!prescriptionID) {
      navigate('RouteAppTabNavigator', { screen: 'RouteTabMyMeds' });
    } else {
      const prescriptionWithRxNumber = await dispatch(fetchPrescriptionFromID(prescriptionID));
      navigate('RouteMedDetails', {
        primaryPrescriptionId: showNewMedDetails ? prescriptionID : Number(prescriptionWithRxNumber.rx_number),
        origin: origin || ORIGIN_NAMES.HOMESCREEN,
      });
    }
  }

  return navigateToMeds;
};
